var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter2 = function SvgTwitter2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.143 3.035c-.835.37-1.732.62-2.675.733a4.67 4.67 0 0 0 2.049-2.578 9.3 9.3 0 0 1-2.959 1.13 4.66 4.66 0 0 0-7.938 4.25A13.23 13.23 0 0 1 2.02 1.702a4.66 4.66 0 0 0 1.442 6.22 4.647 4.647 0 0 1-2.11-.583v.06a4.66 4.66 0 0 0 3.737 4.568 4.692 4.692 0 0 1-2.105.08 4.661 4.661 0 0 0 4.353 3.234 9.348 9.348 0 0 1-5.787 1.995 9.5 9.5 0 0 1-1.111-.065 13.175 13.175 0 0 0 7.14 2.093c8.57 0 13.254-7.098 13.254-13.254 0-.2-.005-.402-.014-.602a9.47 9.47 0 0 0 2.323-2.41l.003-.003Z",
    fill: "ivory"
  })));
};
export default SvgTwitter2;